// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"60b59f41","100":"5e3dfad7"}[chunkId] + ".chunk.css";
};